'use strict';

var React = require('react');
var Typography = require('./Typography-fd6f932a.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function Text({ variation = "default", size = "base", align = "start", children, maxLines = "unlimited", }) {
    const textColors = {
        default: "text",
        subdued: "textSecondary",
        success: "success",
        error: "critical",
        warn: "warning",
        info: "informative",
        disabled: "disabled",
    };
    const maxLineToNumber = {
        single: 1,
        small: 2,
        base: 4,
        large: 8,
        larger: 16,
        unlimited: undefined,
    };
    return (React__default["default"].createElement(Typography.Typography, { textColor: textColors[variation], size: size, numberOfLines: maxLineToNumber[maxLines], align: align }, children));
}

exports.Text = Text;
